import React from "react";
import "./ReportStep.css";
import { REPORT_TYPES } from "../../../conts/simulationConstants";
import ReportLoader from "../../atoms/reportLoader/ReportLoader";

const ReportStep = ({ onBack, report, reportType, onRetry }) => {
  const label =
    REPORT_TYPES.find((t) => t.id === reportType)?.label ?? "Rapport";

  return (
    <div className="report-step">
      <div className="report-step__body">
        <header className="report-step__header">
          <div>
            <h2>Rapport</h2>
            <p>{label}</p>
          </div>
          <div className="report-step__actions">
            {report.data && (
              <a
                className="report-step__btn report-step__btn--outline"
                href={report.data.url}
                download={report.data.filename}
              >
                Exporter PDF
              </a>
            )}
          </div>
        </header>

        {report.isLoading && <ReportLoader label={label} />}

        {report.error && (
          <div className="report-step__alert" role="alert">
            <p>{report.error}</p>
            <button
              type="button"
              className="report-step__btn report-step__btn--outline"
              onClick={onRetry}
            >
              Réessayer
            </button>
          </div>
        )}

        {report.data && (
          <iframe
            className="report-step__preview"
            src={report.data.url}
            title={label}
          />
        )}
      </div>

      <footer className="report-step__footer">
        <button
          type="button"
          className="report-step__btn report-step__btn--ghost"
          onClick={onBack}
        >
          Modifier les paramètres
        </button>
      </footer>
    </div>
  );
};

export default ReportStep;
